export const validation = {
  required: "campo obrigatório",
  email: "e-mail inválido",
  phone: "telefone inválido",
};
